import { axiosInstance as api } from "../helpers/request";
import { IAudio } from "../types/models";

const base = (streamId: string) => `/streams/${streamId}/audio`;

class AudioService {
  savePresignedAudio(
    streamId: string,
    {
      originalName,
      Key,
      folderId,
    }: {
      originalName: string;
      Key: string;
      folderId?: string;
    },
  ) {
    return api.post<IAudio>(`${base(streamId)}/presigned/save`, {
      originalName,
      Key,
      folderId,
    });
  }

  getAudioList(
    streamId: string,
    {
      query = "",
      pageNumber,
      folderId,
    }: {
      query?: string;
      pageNumber: number;
      folderId?: string;
    },
  ) {
    let url = `${base(streamId)}?search=${query}&page=${pageNumber}&perPage=10000`;
    if (folderId) {
      url += `&folderId=${folderId}`;
    }
    return api.get<{ data: IAudio[] }>(url);
  }

  getAudioById(streamId: string, id: string) {
    return api.get<IAudio>(`${base(streamId)}/${id}`);
  }

  deleteAudio(streamId: string, id: string) {
    return api.delete<IAudio>(`${base(streamId)}/${id}`);
  }

  deleteAudioBatch(streamId: string, ids: string[]) {
    return api.post(`${base(streamId)}/batch-delete`, { ids });
  }

  getDownloadUrl(streamId: string, id: string) {
    return api.get<{ url: string }>(`${base(streamId)}/${id}/download`);
  }

  duplicateAudio(streamId: string, id: string) {
    return api.post<IAudio>(`${base(streamId)}/duplicate/${id}`);
  }

  updateAudio(streamId: string, data: Pick<IAudio, "id"> | Partial<IAudio>) {
    return api.patch<IAudio>(`${base(streamId)}/${data.id}`, data);
  }
}

const AudioServiceInstance = new AudioService();

export default AudioServiceInstance;
